import { Button, Typography } from "@mui/material"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const ChatRecentButton = ({ dir, onClick, sx }) => {
  return (
    <Button
        variant="outlined"
        sx={{
            background: '#FFFFFF', // Same background color as the example
            color: 'primary.black', // Text color similar to the example
            borderRadius: '20px',
            fontWeight: 'bold',
            minWidth: '125px',
            fontSize: '',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '999',
            padding: '2.5px 0px',
            height: 'fit-content',
            borderColor: 'primary.mainBlue',
            '&:hover': {
                background: '#FFFFFF',
            },
            ...sx
        }}
        onClick={onClick}
        endIcon={dir ? <ArrowUpwardIcon sx={{width: '12px'}} /> : <ArrowDownwardIcon sx={{width: '12px'}} />}
    >
        <Typography variant="subText">Most Recent</Typography>
    </Button>
  )
}

export default ChatRecentButton